import { makeUclComponent } from '@rbilabs/universal-components';

import Link from 'components/link';
import { getDesignToken } from 'styles/constants';
export const PrepaidTransferBalanceLink = makeUclComponent(Link).withConfig({
  width: '100%',
  padding: '$3',
  fontWeight: 'bold',
  textAlign: 'center',
  isUnderlined: false,
  textTransform: 'capitalize',
  color: getDesignToken('text-link-default'),

  _hover: {
    color: getDesignToken('text-link-hover'),
  },
});
